export default __webpack_public_path__ + "static/media/question.841e989c.svg";